// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { EnvironmentModel } from 'src/app/_interfaces/environment-model';

// default env, used in dev, for example
export const environmentDefault: EnvironmentModel = {
  production: false,
  msal: {
    auth: {
      clientId: 'f0cb6c16-fe11-4532-8866-346cd397de08',
      authority:
        'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033/',
      redirectUri: window.origin + '/portal',
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  },
  userProfilePictureApiUrl:
    'https://graph.microsoft.com/v1.0/me/photos/48x48/$value',
  userDataApiUrl:
    'https://graph.microsoft.com/v1.0/me?$select=displayName,givenName,mail,surname,userPrincipalName,jobTitle,department,country',
  log_companion_url: '',
  applicationInsightsConnectionString:
    'InstrumentationKey=3081cc45-b1cc-4bb0-982a-4c66a567e37f;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=71879b72-af89-4df8-858b-a875797cffbb',
  showCTStatus: true,
};
